
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import LanguageInfo from './LanguageInfo.vue';
import { currentInstance, getLanguagesHelper } from '@/heplers';
import BlogLink from '@/components/docs-main/blog-pages/BlogLink.vue';
import { parseHrefHelper } from '@/heplers/stringHelpers';

@Component({
  components: {
    BlogLink,
    LanguageInfo,
  },
  filters: {
    parseHref: (fqdn: string) => {
      return parseHrefHelper(fqdn, '/docs/');
    },
    getLanguages: getLanguagesHelper,
  },
})
export default class TutorialsPage extends Vue {
  @Getter('getContent') data: any;
  @State('contentLoading') contentLoading: boolean;
  isKit: boolean = currentInstance === 'kit';
}
